import "./PromoNew.scss";
import flyernew from "../../Assets/Promo (1).webp";
import { ReactComponent as Whatsapp } from "../../Assets/svg/whatsapp.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import flyerLimited from "../../Assets/Promo Limited.jpg";
import newLaunch from "../../Assets/Newlaunch/Maxim.webp";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Rona10Images, Rona5Images } from "../../Assets/Produk/Rona/Rona";
import CardProduct from "../../Component/Card/CardProductDark.jsx";
import dataProduct from "../Product/index.json";

const PromoNew = () => {
  const imageMap = {
    Rona5Images,
    Rona10Images,
  };
  const pointData = {
    poin1: [
      "Free Kulkas Sharp ",
      "Free AC 1 PKT",
      "Free Sepeda Polygon",
      "Free Cutlery Set, Piring dan Gelas",
    ],
    // poin2: [
    //   "BONUS AC TIAP KAMAR",
    //   "VOUCHER FURNISH 50 JUTA*",
    //   "GRANDPRIZE IONIQ 5",
    // ],
  };
  const waOpenNewLaunch = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20(Newlaunch+Rona+Homes)%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0",
      "_blank"
    );
  };
  const waOpenLimited = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20(Promo+Limited)%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0",
      "_blank"
    );
  };
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20(Promo+HUT)%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0",
      "_blank"
    );
  };
  return (
    <div className="section-promo-new">
      <div className="container-promotional">
        <div className="container-promo-newlaunch" id="new-launching">
          <div className="flyer">
            <img src={newLaunch} alt="promo flyer" />
          </div>
          <div className="highlights">
            <h4>
              New Launching <br />
              <b>Rona Homes</b>
            </h4>
            <h5>Start From 750JT-an (hanya 39 unit)</h5>
            <div className="highlights-bottom">
              <div className="msg-hook">
                <div className="container-point">
                  {pointData.poin1.map((item, index) => (
                    <div className="point-item" key={index}>
                      <FontAwesomeIcon icon={faCircleCheck} className="icon" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                {/* <div className="container-point">
                          {pointData.poin2.map((item, index) => (
                            <div className="point-item" key={index}>
                              <FontAwesomeIcon icon={faCircleCheck} className="icon" />
                              <span>{item}</span>
                            </div>
                          ))}
                        </div> */}

                <div className="container-btn" id="newlaunch-btn">
                  <div className="term">*T&C apply</div>
                  <button onClick={waOpenNewLaunch} className="btn">
                    <Whatsapp className="icon" />
                    CONTACT US
                  </button>
                  <div className="disclaimer">
                    *Informasi properti harga, spesifikasi, dan ketersediaan unit dapat berubah sewaktu-waktu, silahkan hubungi kami untuk informasi terbaru
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container" id="rona-units">
          {/* <h3 className="sub-title" id="havena-lakes">
            Havena Lakes
          </h3> */}
          <div className="container-card">
            {dataProduct.cardsRona.map((data, index) => (
              <CardProduct
                carousel={imageMap[data.imagesKey]}
                cardID={data.cardID}
                title={data.title}
                downPaymentType={data.downPaymentType}
                price={data.price}
                details={data.details}
                whatsappLink={data.whatsappLink}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="container-promo-limited" id="promo-limited">
        <div className="flyer">
          <img src={flyerLimited} alt="promo flyer" />
        </div>
        <div className="highlights">
          <h4>THE NEXT GADING SERPONG Summarecon Tangerang Free PPN DTP 50%</h4>
          <div className="highlights-bottom">
            <div className="msg-hook">
              <div className="container-btn" id="limited">
                <div className="term">*T&C apply</div>
                <button onClick={waOpenLimited} className="btn">
                  <Whatsapp className="icon" />
                  Dapatkan Promo Terbatas
                </button>
                <div className="disclaimer">
                  *Informasi properti harga, spesifikasi, dan ketersediaan unit dapat berubah sewaktu-waktu, silahkan hubungi kami untuk informasi terbaru
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-promo-new" id="promo-HUT">
        <h2>Promo Hari Ulang Tahun ke-50 Summarecon</h2>
        <img src={flyernew} alt="Flyer Promo" className="flyer" />
        <div className="container-btn">
          <div className="term">*T&C apply</div>
          <button onClick={waOpen} className="btn">
            <Whatsapp className="icon" />
            Dapatkan Promo HUT
          </button>
          <div className="disclaimer">
            *Informasi properti harga, spesifikasi, dan ketersediaan unit dapat berubah sewaktu-waktu, silahkan hubungi kami untuk informasi terbaru
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoNew;
